import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';

const NewLeagueAdminModal = ({ isOpen, toggle, onSave, leagueId }) => {
    const [email, setEmail] = useState('');

    useEffect(() => {
        if (isOpen) {
            setEmail('');
        }
    }, [isOpen]);

    const handleSave = () => {
        if (!email) {
            alert('Please enter an email address');
            return;
        }
        // Basic email validation
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            alert('Please enter a valid email address');
            return;
        }
        onSave({
            league: leagueId,
            email: email
        });
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Add League Admin</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="email">Email Address *</Label>
                    <Input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="admin@example.com"
                        required
                    />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave} disabled={!email}>
                    Add Admin
                </Button>{' '}
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default NewLeagueAdminModal;
